import { ProductData } from '../../types';
import { StyledSubProduct } from '../style';
import { Box } from '@mui/material';

function BundleSubProduct({
    textFontColorHex,
    quantityDisplay,
    images
}: ProductData) {
    return (
        <StyledSubProduct color={textFontColorHex}>
            <Box className="sub-product__container">
                <img
                    className="sub-product__image"
                    src={images.product}
                    alt="product"
                />
                <Box>
                    <p className={'sub-product__text'}>{quantityDisplay}</p>
                </Box>
            </Box>
        </StyledSubProduct>
    );
}

export default BundleSubProduct;
